const setSelectedDashboard = (state, dashboard) => {
  if (state.selectedDashboard) {
    state.selectedDashboard._id = dashboard._id || '';
    state.selectedDashboard.name = dashboard.name || '';
    state.selectedDashboard.cards = structuredClone(dashboard.cards) || [];
  } else {
    state.selectedDashboard = structuredClone(dashboard);
  }
};

const setSelectedSupervisorDashboard = (state, dashboard) => {
  state.selectedSupervisorDashboard = dashboard;
};

export default {
  setSelectedDashboard,
  setSelectedSupervisorDashboard
};
